import { useState } from 'react'
import { Breadcrumb, Button, Divider, Input, Popover, Checkbox, Form, Select, Radio } from 'antd'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { useCreateMacroData } from '../CreateMacroDataProvider'
import { setFieldData, setSteps } from '../CreateMacroDataProvider/actions'
import { fieldTypes, repeating } from '../descriptions'
import { componentTypes } from '../constants'
import TypeSpecificFields from './TypeSpecificFields'
import DefaultFieldValue from './DefaultFieldValue'
import RelationThroughConfig from './RelationThroughConfig'
import ConditionalRendering from './ConditionalRendering'

FormLikeField = ({ label, children }) ->
  <div style={{ marginBottom: 24 }}>
    <span style={{ marginBottom: 5, display: 'block' }}>{ label }</span>
    { children }
  </div>

InputConfig = ({ fieldKey, setSelected }) ->

  return null unless fieldKey
  [{ fieldData, name, steps }, dispatch] = useCreateMacroData()
  stepIndex = steps.findIndex((step) -> fieldKey in step)
  { key, label, type, isHidden, rules = [], config } = (fieldData[fieldKey] or {})

  isOnPrecedingStep = (stepIndex, fieldId) ->
    steps.findIndex((fields) ->
      fields.find((field) -> field is fieldId)
    ) < stepIndex

  getDefaultLabel = ->
    fieldIndex = steps[stepIndex]?.indexOf(fieldKey) or 0
    key or "Step #{ stepIndex + 1 } field #{ fieldIndex + 1 }"

  setFieldProperty = (
    propKey,
    selector = (({ target: { value }}) -> value)
  ) -> (value) ->
    if propKey is 'type'
      if value in ['select', 'selectOrCreate']
        _.set(fieldData, [fieldKey, 'save', 'type'], 'relation')
      else
        _.unset(fieldData, [fieldKey, 'save'])
    dispatch(
      setFieldData(
        _.set(fieldData, [fieldKey, propKey], selector(value))
      )
    )

  setFieldPropertyManually = (propKey, fieldKey, value) ->
    if propKey is 'type'
      if value in ['select', 'selectOrCreate']
        _.set(fieldData, [fieldKey, 'save', 'type'], 'relation')
      else
        _.unset(fieldData, [fieldKey, 'save'])
    dispatch(
      setFieldData(
        _.set(fieldData, [fieldKey, propKey], value)
      )
    )

  removeField = ->
    dispatch(
      setSteps(
        steps.map((step) ->
          step.filter((field) -> field isnt fieldKey)
        )
      )
    )
    setSelected(undefined)

  <div style={{ flexGrow: 1, padding: '0 20px', overflow: 'auto' }}>
    <Breadcrumb style={{ marginBottom: 20 }}>
      {[name, "Step #{ stepIndex + 1 }", getDefaultLabel()].map((crumb) ->
        <Breadcrumb.Item key={crumb}>{crumb}</Breadcrumb.Item>
      )}
    </Breadcrumb>
    <FormLikeField label="Key">
      <Input
        value={key}
        onChange={(e) ->
          if e.target.value is 'id'
            setFieldPropertyManually('type', fieldKey, 'string')
            setFieldPropertyManually('label', fieldKey, 'Id')
          setFieldProperty('key')(e)
        }
      />
    </FormLikeField>
    <FormLikeField label="Label">
      <Input
        value={if fieldData[fieldKey]?.key is 'id' then 'Id' else label}
        onChange={setFieldProperty('label')}
      />
    </FormLikeField>
    <FormLikeField label={
      <>
        Type
        <Popover title="Field Types" content={ if fieldData[fieldKey]?.key is 'id' then fieldTypes(true) else fieldTypes()}><QuestionCircleOutlined style={{ marginLeft: 5, color: '#58bd91' }} /></Popover>
      </>
    }>
      <Select
        value={if fieldData[fieldKey]?.key is 'id' then 'string' else type}
        onChange={setFieldProperty('type', (val) -> val)}
        style={{ width: '100%' }}
      >
        {_.values(if fieldData[fieldKey]?.key is 'id' then componentTypes['id'] else componentTypes['default']).map((type) ->
          <Select.Option value={type} key={type}>{ _.startCase(type) }</Select.Option>
        )}
      </Select>
    </FormLikeField>
    <DefaultFieldValue fieldKey={fieldKey} />
    <Divider />
    <FormLikeField label="Required">
      <Checkbox
        checked={rules.length > 0}
        onChange={setFieldProperty('rules', ({ target: { checked }}) ->
          if checked
            [{ required: true, message: "#{ label } is required."}]
          else
            []
        )}
      />
    </FormLikeField>

    <Divider />
    <TypeSpecificFields fieldKey={fieldKey} />
    <RelationThroughConfig fieldKey={fieldKey} />
    <Divider />
    <ConditionalRendering fieldKey={fieldKey} />
    <Divider />
      <FormLikeField label={
        <>
          Repeating
          <Popover title="Repeating" content={repeating}><QuestionCircleOutlined style={{ marginLeft: 5, color: '#58bd91' }} /></Popover>
        </>
      }>
        <Checkbox
          checked={_.has(config, 'repeatOn')}
          onChange={setFieldProperty('config', ({ target: { checked }}) -> checked && { repeatOn: undefined })}
        />
      </FormLikeField>
      {if _.has(config, 'repeatOn')
        <FormLikeField label="Repeat source">
          <Select
            value={config?.repeatOn}
            onChange={setFieldProperty('config', (val) -> { repeatOn: val })}
            style={{ width: '100%' }}
          >
            {_.values(fieldData).filter(({ key }) -> key? && key isnt '').map(({ key }) ->
              <Select.Option
                value={key}
                key={key}
                disabled={!isOnPrecedingStep(stepIndex, key)}
              >{ _.startCase(key) }</Select.Option>
            )}
          </Select>
        </FormLikeField>
      }
    <Divider />

    <FormLikeField label="Hidden">
      <Checkbox
        checked={isHidden}
        onChange={setFieldProperty('isHidden', ({ target: { checked }}) -> checked)}
      />
    </FormLikeField>

    <Button
      type="danger"
      onClick={removeField}
      style={{ float: 'right', marginBottom: 20 }}
    >Delete this field</Button>

  </div>

export default InputConfig
